import { configCssVars, registerCssVars } from './configCssVars';
import { getValueByCssVars, findColorCssVarsParentNames, getAllCssVars, generateChildrenColor, } from './util';
export { configCssVars, registerCssVars, getValueByCssVars, findColorCssVarsParentNames, getAllCssVars, generateChildrenColor, };
export default configCssVars;
